module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAK0lEQVQ4y2NgGBTgP5mA9gacAUqdwWM+7QyAaUTH9DNg4MOAWDCIDBjaAABg5jnj/w7+7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_red-cross.png
// module id = 1320
// module chunks = 0